import { type ComponentPropsWithoutRef, type ReactNode } from "react";

import { cva, cx } from "class-variance-authority";

import * as theme from "./StatusBadge.css";

export type StatusBadgeStatus =
    | "success"
    | "default"
    | "error"
    | "processing"
    | "warning"
    | "highFriction"
    | "friction"
    | "noFriction";

const dotStyle = cva(theme.dot, {
    variants: {
        status: {
            success: theme.dotSuccess,
            default: theme.dotDefault,
            error: theme.dotError,
            processing: theme.dotProcessing,
            warning: theme.dotWarning,
            highFriction: theme.dotHighFriction,
            friction: theme.dotFriction,
            noFriction: theme.dotNoFriction,
        },
    },
});

export interface StatusBadgeProps extends ComponentPropsWithoutRef<"span"> {
    status: StatusBadgeStatus;
    // The label shown next to the colored dot.
    children: ReactNode;
}

export function StatusBadge({
    status,
    children,
    className,
    ...props
}: StatusBadgeProps) {
    return (
        <span className={cx(theme.root, className)} {...props}>
            <span className={dotStyle({ status })} />
            <span className={theme.label}>{children}</span>
        </span>
    );
}
